import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { FormInput } from '@alfa-bank/site-form-input';
import { Link } from '@alfa-bank/site-link';
import { Select } from '@alfa-bank/site-select';
import { Text } from '@alfa-bank/site-text-v2';
import { Aligner } from '@alfa-bank/site-aligner';
import { Tag } from '@alfa-bank/site-tag';

import { AutocompleteField } from '../autocomplete-field';

import styles from './styles/styles.css';
import type { TCompanyFields, IDeps } from './models';
import { CompanyFields as Component } from './company-fields';

export const CompanyFields = createWidget<IDeps, TCompanyFields>({
    Aligner,
    FormInput,
    Text,
    AutocompleteField,
    Tag,
    Select,
    Link,
    styles,
})(Component);
